import ErrorPanelContainer from './ErrorPanelContainer';

export default ErrorPanelContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/ErrorPanel/index.js